<template>
    <div class="mod-batrank">
        <van-row class="mod-data-head">
            <van-col span="16">
                <div class="tabs-nav">
                    <a href="javascript:;" class="tabs-nav__item active">总榜</a>
                </div>
            </van-col>
            <van-col span="8" class="ta-right">
                <span>共</span><span>{{winNum}}</span><span>人参与</span>
            </van-col>
        </van-row>
        <div>
            <rank-list v-if="winRank" :list="winRank" thead="连胜场次" type="win"></rank-list>  
        </div>
    </div>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex'
    import RankList from '../mod/rank-list'
    export default {
        data() {
            return {
                winRank : null,
                winNum : null, 
                pageNum : 50
            }
        },
        components:{
            'rank-list' : RankList,
        },
        computed: {
            ...mapGetters('ranking', ['moneyRankingList', 'winRankingList']),            
        },
        methods: {
            ...mapActions('ranking', ['loadMoneyRanking', 'loadWinRanking']),            
            async loadWin(){
                const {pageNum} = this
                const start = 0
                const R = await this.loadWinRanking({
                    start, pageNum
                })
                let list = R.list || []
                this.winRank = list
                this.winNum = R.num || 0
            },
            rankClass(index){
                return index < 3 ? ('sort-' + index) : ''
            },
        },
        created() {
            this.loadWin()
        },
    }
</script>